import { render, staticRenderFns } from "./VerifySignUp.vue?vue&type=template&id=65f40e20"
import script from "./VerifySignUp.vue?vue&type=script&lang=js"
export * from "./VerifySignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports